/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mRankItem.vue?vue&type=template&id=122b6da1&scoped=true"
import script from "./mRankItem.vue?vue&type=script&lang=js"
export * from "./mRankItem.vue?vue&type=script&lang=js"
import style0 from "./mRankItem.vue?vue&type=style&index=0&id=122b6da1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b6da1",
  null
  
)

export default component.exports